import { React, useContext, useEffect, useState } from "react";
import p_Success from ".././assets/images/Success.svg";
import { Link, useLocation } from "react-router-dom";
import { simpleGetCall } from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import { AppContext } from "../context/AppContext";
import { ClimbingBoxLoader } from "react-spinners";

const PaymentSuccess = () => {
  const { PickupId, ageTokan, setAgeTokan, LinkOrderId } =
    useContext(AppContext);
  const [pickUpCodeData, setpickUpCodeData] = useState("");

  const location = useLocation();
  let currentRoute = location.pathname;
  console.log("currentRoute", currentRoute);
  let urlData = location.pathname?.split("/");
  console.log(urlData);
  const orderLinkID = urlData[2];
console.log("orderLinkID",orderLinkID);

  const [key2, value2] = orderLinkID?.split("=");
console.log("value2",value2);

  useEffect(() => {
    if (orderLinkID) {
      getpickupcode();
      getlogApi(1)
    } 
    getpickupcode();
    getlogApi(1)
  }, [orderLinkID]);


  useEffect(() => {
    getlogApi(1)
  }, []);

  const getpickupcode = () => {
    simpleGetCall(ApiConfig.GET_PICKUP_CODE + value2)
      .then((res) => {
        console.log(res);
        setpickUpCodeData(res.pickUpCode);
      })
      .catch((error) => {
        console.log("catch error pickUpCode,", error);
      });
  };

  const getlogApi = (status) => {
    simpleGetCall(ApiConfig.TRANSCTION_LOG + orderLinkID + "&status=" + 1)
      .then((res) => {
        console.log(res);
    
      })
      .catch((error) => {
        console.log("catch error pickUpCode,", error);
      });
  };

  return (
    <>
      <div className="payment_success">
        <div className="innerMainImg">
          <img src={p_Success} alt="" />
        </div>
        {/* <div className="text-center">
          <label className="p-1">
            Please use this pick up code on the vending machine, once it is
            matched successfully your
            <br /> purchased product will be dispensed . <br />
          </label>
        </div>

        <div className=" d-flex justify-content-center BTNS m-0">
          <Link className="mt-4" to="#">
            Pickup Code : <span>{pickUpCodeData}</span>
          </Link>
        </div> */}
        {/* <p className="font-weight-bold text-center my-3">
          Thank you for your business
        </p> */}
      </div>
    </>
  );
};

export default PaymentSuccess;
